// import io from "socket.io-client";
import { io } from "https://cdn.socket.io/4.8.1/socket.io.esm.min.js";


// const socket = io("http://127.0.0.1:5003/");
const socket = io("/");

export {socket};